import React from 'react';
import { NavLink } from 'fluxible-router';
import shallowCompare from '../../lib/shallowCompare';
import ShoppingCart from '../../models/ShoppingCart';
import Store from '../../models/Store';
import BagPng from './images/nav_bag.png';
import BagSvg from './images/nav_bag.svg';
import TealBagPng from './images/nav_bag_highlight.png';
import TealBagSvg from './images/nav_bag_highlight.svg';
import styles from './index.sass';

class ShoppingCartPopover extends React.Component {
  static propTypes = {
    shoppingCart: React.PropTypes.instanceOf(ShoppingCart),
    store: React.PropTypes.instanceOf(Store),
    currentRoute: React.PropTypes.object
  };

  render() {
    let onBagRoute = this.props.currentRoute && this.props.currentRoute.name === 'bag';
    let bagCountIcon;
    if(this.props.shoppingCart && this.props.shoppingCart.items.size) {
      let count = this.props.shoppingCart.items.reduce((sum, item, index) => {
        return sum + item.quantity;
      }, 0);
      bagCountIcon = <span className={styles.count}>{count}</span>;
    }
    let icon = <img className={styles.icon} src={(onBagRoute) ? TealBagPng : BagPng} srcSet={(onBagRoute) ? TealBagSvg : BagSvg} />;

    return (
      <NavLink className={styles.bagLink} routeName="bag">
        {icon}
        {bagCountIcon}
      </NavLink>
    );
  }
}

export default ShoppingCartPopover;



// WEBPACK FOOTER //
// banquet/components/ShoppingCartPopover/index.js